import { render } from "./zhongxiyi-news.vue?vue&type=template&id=899b402a&scoped=true"
import script from "./zhongxiyi-news.vue?vue&type=script&lang=js"
export * from "./zhongxiyi-news.vue?vue&type=script&lang=js"

import "./zhongxiyi-news.vue?vue&type=style&index=0&id=899b402a&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-899b402a"]])

export default __exports__